export default "__VITE_ASSET__CZVnUgpj__"